import { connect } from 'react-redux';

import ConfirmationModal from './confirm_create_presentation_modal.jsx';

import {
  showModal,
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  addMediaLibraryAssetsToGridInSubpage 
} from 'zoomforth_codesbane_editor/action_creators/sections.grid.js';

import {
  beginUploadToTiles
} from 'zoomforth_codesbane_editor/action_creators/sections.grid.js';

import selectFilesWithOs from 'zoomforth_zfutils/select_files_with_os.js';

import SelectMediaFromLibrary 
  from 'zoomforth_codesbane_editor/exterior_editor/editor_modals/select_media_from_library_container.jsx';

const mapStateToProps = () => {
  return {};
};


const mapDispatchToProps = (dispatch, { eid, section }) => (
  {
    onRequestClose: ()=> { 
      dispatch(closeModal()); 
    },
    onUploadClick: ()=> { 
      selectFilesWithOs({ multiple: false, accept: ['.pdf'] }).done((files) => {
        dispatch(beginUploadToTiles(section, eid, files, /* forceAssetType = */ 'ppt'));
        dispatch(closeModal());
      });
    },
    onSelectFromMediaLibraryClick: ()=> {
      dispatch(closeModal()); 
      dispatch(showModal(
        SelectMediaFromLibrary, 
        { 
          multiple: false,
          enabledMediaTypes: ['ppt'],
          enabledMediaWarningMsg: 'You may only select Presentations for this tile',
          onAssetsSelectDone: (assets) => {
            dispatch(addMediaLibraryAssetsToGridInSubpage(section, assets, { eid }));
          }
        }
      ));
    }
  }
);

const ConfirmCreatePresentationForTileModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmationModal);

ConfirmCreatePresentationForTileModal.editorModalName = 'ConfirmCreatePresentationForTileModal';

export default ConfirmCreatePresentationForTileModal;
